import { render, staticRenderFns } from "./UiLedgerAccountSelector.vue?vue&type=template&id=30817706&scoped=true"
import script from "./UiLedgerAccountSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiLedgerAccountSelector.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30817706",
  null
  
)

export default component.exports